module.exports = __webpack_public_path__ + "static/img/wmp769.f0cf602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wmp769.jpg
// module id = szZo
// module chunks = 0